// Third party
import React from 'react';
import classNames from 'classnames';

// Components
import ComparisonItemGroupLabel from './ComparisonItemGroupLabel';
import ComparisonGroupsMenu from './ComparisonGroupsMenu';

// Utils
import { formatMessage } from '../../../../utils/i18n';
import ComparisonItem from '@/types/comparison-item';
import ComparisonItemGroup from '@/types/comparison-item-group';

type Props = {
  item: ComparisonItem;
  grouped?: boolean;
  onRemoveGroup: (group: ComparisonItemGroup) => void;
  scrollbarContainerRef?: HTMLElement;
  positionFixed?: boolean;
  editGroups?: boolean;
};

type State = {
  isMenuOpen: boolean;
};

class ComparisonItemGroups extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = { isMenuOpen: false };
  }

  render() {
    const { item, grouped, onRemoveGroup, scrollbarContainerRef, positionFixed, editGroups } = this.props;
    const groupedLabels = grouped && item.groups && item.groups.length > 3;

    return (
      <div className="comparison-item-groups">
        <div className={classNames('comparison-item-groups-labels', { 'is-grouped': grouped, 'with-few-labels': grouped && !groupedLabels })}>
          {item.groups?.map((group, index: number) => (
            <ComparisonItemGroupLabel
              key={group.itemId}
              group={group}
              position={index}
              groupedLabel={groupedLabels}
              onRemove={onRemoveGroup}
              editGroups={editGroups}
              onAdd={() => {}}
            />
          ))}
        </div>

        {groupedLabels && (
          <ComparisonGroupsMenu
            item={item}
            allGroupsItems={item.groups || []}
            onAddToGroup={() => {}}
            onRemoveFromGroup={onRemoveGroup}
            menuTooltip={formatMessage('Comparison.Groups.Tooltips.MenuLabels')}
            menuIcon="cheveron-down"
            scrollbarContainerRef={scrollbarContainerRef}
            positionFixed={positionFixed}
          />
        )}
      </div>
    );
  }
}

export default ComparisonItemGroups;
